import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {CommissionSettlement} from '../interface/commission-settlement';
import {CommissionContractSettlement} from "../interface/commission-contract-settlement";
import {CommissionAnnex} from "../interface/commission-annex";

@Injectable({
  providedIn: 'root'
})
export class CommissionSettlementService {
  public readonly commissionSettlementListSubject: ReplaySubject<CountedAndPaginated<CommissionSettlement>>
    = new ReplaySubject<CountedAndPaginated<CommissionSettlement>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    subject?: Subject<CountedAndPaginated<CommissionSettlement>>
  ): void {
    this.httpClient.get(`/rest/crm/commission-settlement?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<CommissionSettlement>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.commissionSettlementListSubject.next(result);
        }
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-settlement/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public get(commissionSettlementId: string): Observable<CommissionSettlement> {
    return this.httpClient.get(`/rest/crm/commission-settlement/${commissionSettlementId}`)
      .pipe(first()) as Observable<CommissionSettlement>;
  }

  public downloadSettlementReport(settlementId: string): void {
    this.document.location.href = `/rest/crm/commission-settlement/${settlementId}/report`;
  }

  public downloadSettlementDetailedReport(settlementId: string): void {
    this.document.location.href = `/rest/crm/commission-settlement/${settlementId}/detailed-report`;
  }

  public generateCommissionSettlements(commissionSettlementId: string): Observable<Uuid>  {
    return this.httpClient.post(`/rest/crm/generate-commission-settlement/${commissionSettlementId}`, {})
      .pipe(first()) as Observable<Uuid>;
  }
  public sendRaport(commissionContractSettlementId: string): Observable<CommissionContractSettlement> {
    return this.httpClient.get( `/rest/crm/commission-contract-settlement/${commissionContractSettlementId}/send`)
      .pipe(first()) as Observable<CommissionContractSettlement>;
  }
  public sendPassword(commissionSettlementId: string): Observable<CommissionSettlement> {
    return this.httpClient.get( `/rest/crm/commission-settlement/${commissionSettlementId}/send-password`)
      .pipe(first()) as Observable<CommissionSettlement>;
  }

  public checkCommissionContractSettlement(billingMonth: string, filters: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/commission-contract-settlement/check/${billingMonth}?` + this.filterService.parseFilters(filters), {})
      .pipe(first());
  }

  public hasClosedSettlements(billingMonth: string, filters: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/commission-settlement/method/has-closed-settlements/${billingMonth}?` + this.filterService.parseFilters(filters), {})
      .pipe(first());
  }
}
